"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileTreeItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _StyledFileTreeItemComponents = require("../styled/StyledFileTreeItemComponents");
var _getAssetIcon = require("../util/getAssetIcon");
const FileTreeItem = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    variant = "default",
    assetType,
    title,
    overrides,
    isParent = false,
    isOpen = false,
    childItemCount,
    isSelected = false,
    isActive = false,
    hasBoldTitle = false,
    contentAfter,
    onClick,
    clientIds,
    isItemWithChildren = false,
    onItemWithChildrenChevronButtonClick,
    tabIndex = -1,
    ...otherClickableProps
  } = _ref;
  //override isParent if isItemWithChildren is passed
  let isParentProp = isParent;
  if (isItemWithChildren) isParentProp = false;
  const [isHovered, setIsHovered] = (0, _react.useState)(false);

  /**
   * Memoized arrow icon value - updates when isOpen is changed
   */
  const arrowIcon = (0, _react.useMemo)(() => {
    return isOpen ? /*#__PURE__*/_react.default.createElement(_ursaIcons.ChevronDownIcon, {
      "data-client-id": clientIds?.downArrowIcon,
      size: 16,
      color: (0, _designTokensReact.color)("color--icons--neutral--default"),
      "aria-hidden": "true"
    }) : /*#__PURE__*/_react.default.createElement(_ursaIcons.ChevronRightIcon, {
      "data-client-id": clientIds?.rightArrowIcon,
      size: 16,
      color: (0, _designTokensReact.color)("color--icons--neutral--default"),
      "aria-hidden": "true"
    });
  }, [isOpen, clientIds?.rightArrowIcon, clientIds?.downArrowIcon]);
  const a11yRole = (0, _react.useMemo)(() => {
    return isParentProp || assetType === "folder" || assetType === "collection" || assetType === "file" ? "group" : "treeitem";
  }, [isParentProp, assetType]);
  return (
    /*#__PURE__*/
    //Outer div is needed because buttons cannot be given a role='treeitem'
    _react.default.createElement("div", {
      role: a11yRole,
      "aria-selected": variant === "selectable" ? isSelected : false,
      "aria-expanded": isOpen,
      ref: ref
    }, /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledWrapper, (0, _extends2.default)({
      onClick: onClick,
      isActive: isActive,
      isSelected: isSelected,
      tabIndex: tabIndex,
      isParent: isParentProp,
      isContentLibrary: assetType === "content-library",
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    }, otherClickableProps), /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledIconsWrapper, null, isParentProp && arrowIcon, isItemWithChildren && /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledChevronContainer, {
      "data-client-id": clientIds?.chevronIconButtonWrapper
    }, /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledChevronButton, {
      size: "xsmall",
      iconBefore: arrowIcon,
      appearance: "secondary-empty",
      onClick: e => {
        e.stopPropagation();
        onItemWithChildrenChevronButtonClick && onItemWithChildrenChevronButtonClick(e);
      }
    })), /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledAssetIconWrapper, {
      "data-client-id": clientIds?.iconWrapper
    }, (0, _getAssetIcon.getAssetIcon)({
      isHovered,
      isActive,
      isOpen,
      isParent: isParentProp,
      assetType,
      iconVariantMap: _constants.iconVariantMap,
      variant
    }))), overrides?.title ? overrides.title : /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledTitle, {
      system: "ursa",
      variant: `TT-Norms-Pro--14px--${hasBoldTitle ? "700w" : "500w"}`,
      lineClamp: 1,
      width: "auto",
      "data-client-id": clientIds?.title
    }, title, childItemCount && /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledSpan, {
      "data-client-id": clientIds?.childItemCount,
      renderAs: "span",
      system: "ursa",
      variant: "TT-Norms-Pro--14px--500w",
      lineClamp: 1
    }, "(", childItemCount, ")")), contentAfter && /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledContentAfterWrapper
    //prevent onClicks from any contentAfter children from interfering with the item's built in onClick stuff
    //while we're at it, handle resetting of isHovered state of the item on any contentAfter onClicks
    , {
      onClick: e => {
        e.stopPropagation();
        setIsHovered(false);
      }
    }, contentAfter), variant === "selectable" && /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledCheckmarkWrapper, null, isSelected && /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledCheckmarkIcon, {
      "data-client-id": clientIds?.checkmarkIcon,
      size: 20,
      "aria-hidden": "true"
    }))))
  );
});
exports.FileTreeItem = FileTreeItem;
FileTreeItem.displayName = "FileTreeItem";
//# sourceMappingURL=FileTreeItem.js.map